import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-departments',
  templateUrl: './departments.component.html'
})
export class DepartmentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
